import { useMemo } from 'react'
import { toPairs } from 'ramda'

import { useSelectionStateContext } from './use-selection-state-context'


export function useSelectionAsArray() {
  const { selection } = useSelectionStateContext()
  const res = useMemo(() => {
    return toPairs(selection).reduce((acc, [id, selected]) => {
      if (selected) {
        acc.push(id)
      }
      return acc
    }, [] as Array<string>)
  }, [selection])

  return res
}
